module.exports = __webpack_public_path__ + "525d5b452809b3172a2a34e26d9db546.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/roboto-bold.woff
// module id = 590
// module chunks = 0